import {
  ApiOperations,
  ApiOperationsWithAuthToken,
  PartialData,
  QueryParameters,
} from '@di-nxt/resource-container';
import {useGetTokensWithRefresh} from '../../auth';

export const createUseWithAuthTokens = <
  TData extends PartialData<TIdKey, any>,
  // eslint-disable-next-line @typescript-eslint/ban-types
  TParameters extends QueryParameters = {},
  TPayload = Record<string, unknown>,
  TIdKey extends keyof TData = keyof TData
>(
  useWithAuthOperations: () => ApiOperationsWithAuthToken<
    TData,
    TParameters,
    TPayload,
    TIdKey
  >,
): (() => ApiOperations<TData, TParameters, TPayload, TIdKey>) => {
  return () => {
    const withAuthOperations = useWithAuthOperations();
    const accessTokenWithRefresh = useGetTokensWithRefresh();

    return {
      getItem: (id: TData[TIdKey]) =>
        accessTokenWithRefresh().then(authTokens =>
          withAuthOperations.getItem(id, authTokens),
        ),
      getList: (parameters?: TParameters) =>
        accessTokenWithRefresh().then(authTokens =>
          withAuthOperations.getList(parameters, authTokens),
        ),
      update: (id: TData[TIdKey], data: Omit<TData, TIdKey>) =>
        accessTokenWithRefresh().then(authTokens =>
          withAuthOperations.update(id, data, authTokens),
        ),
      remove: (id: TData[TIdKey]) =>
        accessTokenWithRefresh().then(authTokens =>
          withAuthOperations.remove(id, authTokens),
        ),
      create: (payload: TPayload) =>
        accessTokenWithRefresh().then(authTokens =>
          withAuthOperations.create(payload, authTokens),
        ),
    };
  };
};
